import { DashboardView } from './Dashboard.view'
import { DashboardWidgets } from './Widgets'

const Dashboard = () => {
  return <DashboardView widgets={DashboardWidgets} />
}

export { Dashboard }
